// @ts-ignore
export const PodOS = window.PodOS ? new window.PodOS.PodOS() : null;
